import React from "react";
import { DivMain, Spinner, Container } from "./stylesLoading";

export default function Loading({ mostrar }) {
    return (
        <DivMain mostrar={mostrar}>
            <Container>
                <svg viewBox="0 0 100 100">
                    <defs>
                        <filter id="shadow">
                            <feDropShadow
                                dx="0"
                                dy="0"
                                stdDeviation="1.5"
                                flood-color="#fc6767"
                            />
                        </filter>
                    </defs>
                    <Spinner id="spinner" cx="50" cy="50" r="45" />
                </svg>
            </Container>
        </DivMain>
    );
}
